import React from "react";

const weekendImage = `${process.env.PUBLIC_URL}/haseeb-weeekend.png`;

const WeekendPortrait = ({ className = "salva-weekend-image dark-weekend-image" }) =>
{
    return (
      <div className={className}>
        <img
          src={weekendImage}
          alt="Haseeb playing PC games on weekends"
          className="salva-weekend-img"
        />
      </div>
    );
};

export default WeekendPortrait;
